import { Switch } from "@mui/material";
import React from "react";

const Photos = () => {
  return (
    <div className="mainbarfiltercomponents">
      <div className="propertyboxes">
        <Switch defaultChecked />
        <p>Photos</p>
      </div>
    </div>
  );
};

export default Photos;
